export enum ControlEditionContext {
    None = 'none',
    Dirty = 'dirty',
    HasErrors = 'has-errors',
    Pristine = 'pristine'
}
